import { createCompositeTabsDomStructure as DomStrcuture } from './dom-structure';

export const createCompositeTabsElements = {
  DomStrcuture,
};
